export default __webpack_public_path__ + "static/media/google-developers.00127a2e.svg";